import { NgModule } from '@angular/core';
 
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
 
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatTabsModule} from '@angular/material/tabs';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatMenuModule} from '@angular/material/menu';
import {FileUploadModule} from 'primeng/fileupload';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import {MatBadgeModule} from '@angular/material/badge';
import {MatSelectModule} from '@angular/material/select';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDialogModule} from '@angular/material/dialog';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { CommonModule } from "@angular/common";
 

@NgModule({
    imports: [
        CommonModule ,
        MatButtonModule,
        MatNativeDateModule,
        
        MatCardModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatPaginatorModule,
        MatRadioModule,
        MatSidenavModule,
        MatSnackBarModule,
        MatSortModule,
        MatStepperModule,
        MatTableModule,
        MatToolbarModule,
        MatTooltipModule,
        MatGridListModule,
        MatAutocompleteModule,
        MatSelectModule ,
        MatSlideToggleModule,
        MatDatepickerModule,
        MatMenuModule,
        MatCheckboxModule,
        FileUploadModule,
        PdfViewerModule,
        MatDialogModule ,
        MatBadgeModule,
        MatTabsModule 
 
     ],
     providers: [  { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }
    ],
    exports:[ 
        MatButtonModule,
        MatCardModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatPaginatorModule,
        MatRadioModule,
        MatSidenavModule,
        MatSnackBarModule,
        MatSortModule,
        MatStepperModule,
        MatTableModule,
        MatToolbarModule,
        MatTooltipModule,
        MatGridListModule,
        MatAutocompleteModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatDatepickerModule,
        MatMenuModule,
        MatCheckboxModule,
        FileUploadModule,
        PdfViewerModule,
        MatDialogModule,
        MatBadgeModule,
        MatTabsModule,

    ]
})
 
export class MaterialModule { }